var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPixelSmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3058_7056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.565 0H7.15625V7.34127H56.565V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5644 56.491H7.14941V63.8322H56.5644V56.491Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14929 7.44043H0V56.4902H7.14929V7.44043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5781 18.2712H17.2915V25.5586H24.5781V18.2712Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2915 41.9161H24.5672V49.191H31.8539H39.1405V41.9106H46.4216V34.6232H39.135V41.9044H31.8539H24.5789V34.6295H17.2915V41.9161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4219 18.2712H39.1353V25.5586H46.4219V18.2712Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7142 7.33972H56.5649V56.4886H63.7142V7.33972Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3058_7056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPixelSmile);
export default __webpack_public_path__ + "static/media/icon-pixel-smile.57c108ac0ce524e47aae8b7d2d18fa7e.svg";
export { ForwardRef as ReactComponent };